import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Box from '@zenbusiness/zui/Box';
import Link from '@zenbusiness/zui/Link';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { MERCURY_REFERRED_CUSTOMER_AGREEMENT_URL } from '#client/constants/url';

/**
 * Mercury's required disclosures, shown beneath the partner cards.
 * @param {object} props Component props
 * @param {string} props.appPageName Clickstream page name
 * @param {string} props.elementName Clickstream element name for the agreement link
 * @returns {import('react').ReactElement} The footnotes
 */
export default function PartnerFootnotes({ appPageName, elementName }) {
  const agreementLinkPressed = useLinkPressedCallback({
    elementText: 'Mercury Referred Customer Agreement',
    elementName,
    appPageName
  });

  return (
    <Box>
      <Text
        color="tertiary"
        size="xs"
      >
        *Mercury is a fintech company, not an FDIC-insured bank. Banking services provided through
        Choice Financial Group and Column N.A., Members FDIC.
      </Text>
      <Text
        color="tertiary"
        size="xs"
      >
        **Bonus is subject to terms. Eligibility requires meeting the deposit threshold and
        maintaining it for at least one full day. Full conditions and bonus details can be found in
        the{' '}
        <Link
          href={MERCURY_REFERRED_CUSTOMER_AGREEMENT_URL}
          onClick={agreementLinkPressed}
          rel="noreferrer"
          target="_blank"
        >
          Mercury Referred Customer Agreement
        </Link>
        .
      </Text>
    </Box>
  );
}

PartnerFootnotes.propTypes = {
  appPageName: PropTypes.string.isRequired,
  elementName: PropTypes.string.isRequired
};
